import Breadcrumbs from '@storeblocks/breadcrumbs';
import { type FC } from 'react';
import { styled } from 'styled-components';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { CenteredPageContent } from '@/components/CenteredPageContent';
import { InternalLink } from '@/components/InternalLink';
import { MainContent } from '@/components/MainContent';
import { PageHeading } from '@/components/PageHeading';
import { useTexts } from '@/hooks/useTexts';

export const VotingPage: FC = () => {
  const organizationCmId = useOrganizationCmId();
  const texts = useTexts();

  return (
    <CenteredPageContent data-test="engagement-page">
      <Breadcrumbs expandAllAriaLabel={texts.breadcrumbs.expandAllAriaLabel}>
        <InternalLink to={`/${organizationCmId}`}>
          {texts.menu.links.home}
        </InternalLink>
        <InternalLink to={`/${organizationCmId}/sustainability`}>
          {texts.menu.links.sustainability}
        </InternalLink>
        <InternalLink to={`/${organizationCmId}/sustainability/voting`}>
          {texts.menu.links.voting}
        </InternalLink>
      </Breadcrumbs>

      <MainContent>
        <PageHeading header={texts.pages.voting.title} />

        <StyledIframe src="https://vds.issgovernance.com/vds/#/MTAzNjM=/" />
      </MainContent>
    </CenteredPageContent>
  );
};

const StyledIframe = styled.iframe`
  height: 6000px;
  border: none;
`;
